const moduleName = 'accordion';

module.exports = () => {

    Array.from(document.querySelectorAll('.js-accordion')).forEach((self) => {
        if (self.dataset[moduleName + 'Init'] === 'true') return;
        self.dataset[moduleName + 'Init'] = true;

        const accordion = self;
        const outer = accordion.querySelector('.js-accordion-outer');
        const inner = accordion.querySelector('.js-accordion-inner');

        accordion.addEventListener('click', () => {
            if (accordion.classList.contains('_open')) {
                outer.style.height = outer.offsetHeight + 'px';

                setTimeout(() => {
                    outer.style.height = 0;

                    setTimeout(() => {
                        outer.style.height = '';
                        accordion.classList.remove('_open');
                    }, 300);
                }, 10);
            } else {
                outer.style.height = 0;

                setTimeout(() => {
                    outer.style.height = inner.offsetHeight + 'px';
                    accordion.classList.add('_open');

                    setTimeout(() => {
                        outer.style.height = '';
                    }, 300);
                }, 10);
            }
        });
    });

};